// Import individual menu configurations
import DashboardMenu from './DashboardMenu';
import GroupListMenu from './GroupListMenu';
import VisitorListMenu from './VisitorListMenu';
import ChangePasswordMenu from './ChangePasswordMenu';

// Function to generate sidebar menu items based on user permissions and change password status
export const itemlist = (customization) => {
    try {
        // Get the first (and likely only) user object from Redux state
        const user = customization?.userDetail?.[0];

        // Extract permission and user detail objects
        const permissions = user?.permission || {};
        const userDetails = user?.user_detail || {};

        // If user hasn't changed their password, force them to only see the Change Password menu
        if (!userDetails?.change_password) {
            return { items: [ChangePasswordMenu] };
        }

        // Initialize menu with the Dashboard always visible
        const items = [DashboardMenu];

        // Conditionally show GroupList menu if user has view access to any of these entities
        if (
            permissions['corporate_park']?.includes('view') ||
            permissions['building']?.includes('view') ||
            permissions['tenant']?.includes('view') ||
            permissions['user']?.includes('view')
        ) {
            items.push(GroupListMenu);
        }

        // Show Visitor List menu if user has view permission
        if (permissions['visitor']?.includes('view')) {
            items.push(VisitorListMenu);
        }

        // Change password menu should always be included if change_password is true
        items.push(ChangePasswordMenu);

        // Return final list of permitted items
        return { items };
    } catch (error) {
        // Log any unexpected error and return empty menu
        console.error('Error generating menu item list:', error);
        return { items: [] };
    }
};

// import DashboardMenu from './DashboardMenu';
// import GroupListMenu from './GroupListMenu';
// import VisitorListMenu from './VisitorListMenu';
// import ChangePasswordMenu from './ChangePasswordMenu';

// export const itemlist = (customization) => {
//     try {
//         const user = customization?.userDetail?.[0];
//         const permissions = user?.permission || {};
//         // const userDetails = user?.user_detail || {};

//         const items = [DashboardMenu];

//         // Add GroupListMenu if user has permission
//         if (
//             permissions['corporate_park']?.includes('view') ||
//             permissions['building']?.includes('view') ||
//             permissions['tenant']?.includes('view') ||
//             permissions['user']?.includes('view')
//         ) {
//             items.push(GroupListMenu);
//         }

//         // Add VisitorListMenu if user has permission
//         if (permissions['visitor']?.includes('view')) {
//             items.push(VisitorListMenu);
//         }

//         // Add ChangePasswordMenu only if user has change_password flag
//         items.push(ChangePasswordMenu);

//         return { items };
//     } catch (error) {
//         console.error('Error fetching item list:', error);
//         return { items: [] };
//     }
// };
// import DashboardMenu from './DashboardMenu';
// import GroupListMenu from './GroupListMenu';
// import VisitorListMenu from './VisitorListMenu';
// import ChangePasswordMenu from './ChangePasswordMenu';

// export const itemlist = (customization) => {
//     try {
//         console.log('customization', customization);

//         console.log('corporate park view', customization?.userDetail?.[0]?.permission['corporate_park']?.includes('view') ?? false);
//         console.log('change password', customization?.userDetail?.[0]?.user_detail?.change_password);

//         const items = customization?.userDetail?.[0]?.user_detail?.change_password
//             ? [DashboardMenu, GroupListMenu, VisitorListMenu, ChangePasswordMenu]
//             : [ChangePasswordMenu];

//         console.log('items in itemList', items);

//         return { items };
//     } catch (error) {
//         console.error('Error fetching item list:', error);
//         return { items: [] };
//     }
// };
